var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.product
    ? _c(
        "div",
        [
          _c("div", { staticClass: "product-content" }, [
            _c("div", { staticClass: "product-info" }, [
              _c("div", { staticClass: "product-price" }, [
                _vm._v(
                  "$" +
                    _vm._s(
                      new Intl.NumberFormat().format(_vm.product["total-price"])
                    )
                ),
              ]),
              _vm._v(" "),
              !_vm.hideTitle
                ? _c("div", { staticClass: "product-title" }, [
                    _vm._v(_vm._s(_vm.product["product-name"])),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.type === "one"
              ? _c("div", { staticClass: "product-image" }, [
                  !_vm.hideTitle && _vm.product["product-image-url"]
                    ? _c("img", {
                        attrs: { src: _vm.product["product-image-url"] },
                      })
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          !_vm.hideDescription
            ? [
                _vm.type === "mandatory" && _vm.product["product-description"]
                  ? _c("div", { staticClass: "product-desc" }, [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.product["product-description"]),
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.type !== "mandatory" && _vm.product["product-description"]
                  ? _c("div", {
                      staticClass: "product-desc",
                      domProps: {
                        innerHTML: _vm._s(_vm.product["product-description"]),
                      },
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }